module.exports = __webpack_public_path__ + "img/people.2cde56e1.png";